import { render, staticRenderFns } from "./add-exam-form-confirm.vue?vue&type=template&id=42f84189"
import script from "./add-exam-form-confirm.vue?vue&type=script&lang=ts"
export * from "./add-exam-form-confirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports